import React from 'react';

import {
  CapaQuotationChatMessageRfq,
  CapaQuotationChatMessageType
} from '@generated/graphql';

import { Divider } from '@material-ui/core';
import { CheckCircleOutline } from '@material-ui/icons';

import { CustomizedTypography } from '@components/Customized';
import { useSelector } from '@store';

interface Props {
  data?: CapaQuotationChatMessageRfq;
  isConfirmedByOther: boolean;
}

const ConfirmBubble: React.FC<Props> = ({ data, isConfirmedByOther }) => {
  const isOld = useSelector((state) => state.chat.isOld);

  const rfqDataInChatMessage = data?.rfq;

  const userManagerName = rfqDataInChatMessage?.userManagerName ?? '';
  const userOrganizationName = rfqDataInChatMessage?.userOrganizationName ?? '';
  const partnerManagerName = rfqDataInChatMessage?.partnerManagerName ?? '';
  const partnerOrganizationName =
    rfqDataInChatMessage?.partnerOrganizationName ?? '';
  const messageType = data?.messageType;
  const isRfqExpirationConfirm =
    messageType === CapaQuotationChatMessageType.RfqExpirationConfirm;

  const render = () => {
    if (isRfqExpirationConfirm && isConfirmedByOther && !isOld) {
      return (
        <>
          <CustomizedTypography
            variant="body2"
            color="textPrimary"
            fontWeight="bold"
          >
            <span className="primary-text">{userOrganizationName}</span>&nbsp;
            <span className="primary-text">{userManagerName}</span>&nbsp;님이
          </CustomizedTypography>
          <CustomizedTypography
            variant="body2"
            color="textPrimary"
            fontWeight="bold"
          >
            <span className="primary-text">타업체</span>에게 발주했습니다.
          </CustomizedTypography>
        </>
      );
    }

    if (isRfqExpirationConfirm && isConfirmedByOther && isOld) {
      return (
        <>
          <CustomizedTypography
            variant="body2"
            color="textPrimary"
            fontWeight="bold"
          >
            <span className="primary-text">{userOrganizationName}</span>&nbsp;
            <span className="primary-text">{userManagerName}</span>&nbsp;님이
          </CustomizedTypography>
          <CustomizedTypography
            variant="body2"
            color="textPrimary"
            fontWeight="bold"
          >
            <span className="primary-text">타업체</span>와 확정했습니다.
          </CustomizedTypography>
        </>
      );
    }

    return (
      <>
        <CustomizedTypography
          variant="body2"
          color="textPrimary"
          fontWeight="bold"
        >
          {userOrganizationName}&nbsp;
          {userManagerName}&nbsp;
          <span className="primary-text">님과</span>
        </CustomizedTypography>
        <CustomizedTypography
          variant="body2"
          color="textPrimary"
          fontWeight="bold"
        >
          {partnerOrganizationName}
          &nbsp;{partnerManagerName}
          님이&nbsp;
          <span className="primary-text">업체확정이 되었습니다.</span>
        </CustomizedTypography>
      </>
    );
  };

  return (
    <div className="message-container">
      <Divider className="message-divider" />
      <CheckCircleOutline className="checkCircleIcon" fontSize="small" />
      {render()}
      <Divider className="message-divider" />
    </div>
  );
};

export default ConfirmBubble;
